const accordionTitleMap = new Map([
  ['basicDetails', 'Basic Details'],
  ['addressAndContacts', 'Ach Credit Address And Contact'],
  ['creditTransferReports', 'Ach Credit Transfer Reports'],
  ['creditTransferSpecific', 'Ach Credit Transfer Specific Details'],
  ['primaryAndAdditionalContact', 'Primary And Additional Contact Details'],
  ['mandateServiceUserTraining', 'Mandatory Service User Training']
])

const countryAccordionMap = new Map([
  ['bangladesh', ['basicDetails', 'addressAndContacts', 'creditTransferReports']],
  ['bahrain', ['basicDetails', 'addressAndContacts', 'creditTransferReports']],
  ['canada', ['basicDetails', 'addressAndContacts', 'creditTransferReports', 'creditTransferSpecific']],
  ['china', ['basicDetails', 'addressAndContacts', 'creditTransferReports', 'creditTransferSpecific']],
  ['czechrepublic', ['basicDetails', 'addressAndContacts', 'creditTransferReports']],
  ['egypt', ['basicDetails', 'addressAndContacts', 'creditTransferReports']],
  ['hongkong', ['basicDetails', 'addressAndContacts', 'creditTransferReports', 'creditTransferSpecific']],
  ['india', ['basicDetails', 'addressAndContacts', 'creditTransferReports']],
  ['kuwait', ['basicDetails', 'addressAndContacts', 'creditTransferReports']],
  ['oman', ['basicDetails', 'addressAndContacts', 'creditTransferReports']],
  ['philippines', ['basicDetails', 'addressAndContacts', 'creditTransferReports']],
  ['poland', []],
  ['qatar', ['basicDetails', 'addressAndContacts', 'creditTransferReports']],
  ['southafrica', ['basicDetails', 'addressAndContacts', 'creditTransferReports']],
  ['switzerland', ['basicDetails', 'addressAndContacts', 'creditTransferReports']],
  ['taiwan', ['basicDetails', 'addressAndContacts', 'creditTransferReports', 'creditTransferSpecific']],
  ['unitedarabemirates', ['basicDetails', 'addressAndContacts', 'creditTransferReports']],
  ['unitedkingdomhsbcuk_newdirect', ['basicDetails', 'addressAndContacts', 'creditTransferSpecific', 'primaryAndAdditionalContact', 'mandateServiceUserTraining']],
  ['unitedkingdomhsbcuk_newindirect', ['basicDetails', 'addressAndContacts', 'creditTransferSpecific', 'primaryAndAdditionalContact', 'mandateServiceUserTraining']],
  ['unitedkingdomhsbcuk_transferofsponsorshipdirect', ['basicDetails', 'addressAndContacts', 'creditTransferSpecific', 'primaryAndAdditionalContact']],
  ['unitedkingdomhsbcuk_transferofsponsorshipindirect', ['basicDetails', 'addressAndContacts', 'creditTransferSpecific', 'primaryAndAdditionalContact']],
  ['unitedkingdomhsbcuk_newdca', ['basicDetails', 'addressAndContacts', 'creditTransferSpecific', 'primaryAndAdditionalContact']],
  ['unitedkingdomhsbcuk_transferofsponsorshipdca', ['basicDetails', 'addressAndContacts', 'creditTransferSpecific', 'primaryAndAdditionalContact']],
  ['unitedstatesofamerica', ['basicDetails', 'addressAndContacts', 'creditTransferReports']]
]);

const aggregateBoxCount = new Map([
  ['emailContactId', 3], ['additionalSUNs', 8], ['bureauDetails', 5], ['softwareSupplierDirect', 5]
])

export const dropDownDataSourceMap = new Map([
  ['addAccountDropdown', 'availableAccounts'],
  ['serviceChargeAcc', 'availableAccounts'],
  ['primaryDebitAccId', 'availableAccounts'],
  ['additionalDebitAccountId', 'availableAccounts'],
  ['frequencyOfSubmission', 'availableFreqOfSubmission'],
  ['limitPeriod', 'availableLimitPeriods'],
  ['achAccountsId', 'availableAccounts'],
  ['bacsDCAId', 'availableAccounts'],
  ['bacsCRAccId', 'availableAccounts'],
  ['bacsCRLimitPeriodId', 'availableLimitPeriods'],
  ['addressId', 'availableAddresses'],
  ['contactId', 'availableContacts'],
  ['echannelId', 'availableEchannels'],
  ['reportDeliveryMethod', 'availableReportDeliveryMethods'],
  ['empPhoneNum', 'availableContacts'],
  ['emailAddId', 'availableContacts'],
  ['smsContactId', 'availableContacts'],
  ['deliveryMethod', 'availableDeliveryMethods'],
  ['eChannelType', 'availableEchannelTypes'],
  ['reportFormat', 'availableReportFormat'],
  ['eftoutputFile', 'availableEftOutputFiles'],
  ['trainingContact', 'availableContacts'],
  ['securityId', 'availableContacts']
]);

export const accordionFieldsMap = new Map([
  ['oman_basicDetails', ['static_text_title',
    new Map([['paymentTypes:guidecheckbox_wps', ['guidedropdownlist_primaryDebitAccId', 'guidedropdownlist_additionalDebitAccountId', 'guideaggregateformbox_firstParty', 'guideaggregateformbox_secondParty',
      'guidetextbox_empIdentificationNo', 'guidetextbox_empNumberType', 'guidetextbox_payerIdentificationNo', 'guidetextbox_payerNumberType', 'guidetextbox_employerNameOpt', 'guidedropdownlist_addressId', 'guidetextbox_gradeNo', 'guidedropdownlist_empPhoneNum']],
    ['paymentTypes:guidecheckbox_spo', ['guidedropdownlist_primaryDebitAccId', 'guidedropdownlist_additionalDebitAccountId', 'guideaggregateformbox_firstParty', 'guideaggregateformbox_secondParty']],
    ['paymentTypes:guidecheckbox_nonWps', ['guidedropdownlist_primaryDebitAccId', 'guidedropdownlist_additionalDebitAccountId', 'guideaggregateformbox_firstParty', 'guideaggregateformbox_secondParty']]
    ]),
    'guidedropdownlist_serviceChargeAcc', 'guidetextbox_serviceChargeAccName', 'guidebutton_saveAndRefresh'
  ]
  ],
  ['oman_addressAndContacts', ['guidedropdownlist_addressId', 'guidetextbox_forTheAttentionOf',
    new Map([['guideradiobutton_designateContact', ['guidedropdownlist_contactId']]]),
    'guidebutton_saveAndRefresh'
  ]
  ],
  ['oman_creditTransferReports', [new Map([['guideradiobutton_isReportingRequired', ['static_text_title',
    new Map([['reportFormats:guidecheckbox_eChannel', ['guidedropdownlist_echannelId']],
    ['reportFormats:guidecheckbox_other', ['guidetextbox_otherReportFormat']]
    ])

  ]
  ]
  ]),
    'guidebutton_saveAndRefresh'
  ]],

  ['hongkong_basicDetails', ['guideaggregateformbox_achAccounts', 'guidedropdownlist_serviceChargeAcc', 'guidetextbox_serviceChargeAccName', 'guidebutton_saveAndRefresh'
  ]
  ],
  ['hongkong_addressAndContacts', ['guidedropdownlist_addressId', 'guidetextbox_forTheAttentionOf',
    new Map([['guideradiobutton_designateContact', ['guidedropdownlist_contactId']]]),
    'guidebutton_saveAndRefresh'
  ]
  ],
  ['hongkong_creditTransferReports', [new Map([['guideradiobutton_isReportingRequired', ['static_text_title',
    new Map([['reportFormats:guidecheckbox_eChannel', ['guidedropdownlist_echannelId']],
    ['reportFormats:guidecheckbox_other', ['guidetextbox_otherReportFormat']]
    ])
  ],
  ]
  ]),
  new Map([['static_text_heading', 'Report Format']]),
  new Map([['electronicReportFormats:guideradiobutton_electronicReportFormats', [new Map([['electronicReportFormats:full', ['reportToByOrderedBy:guideradiobutton_reportToByOrderedBy',
    new Map([['static_text_note', 'Return Report - Daily Report to be printed on the  1st to 3rd Working Day after Value Date.']]),
    new Map([['static_text_heading', 'Report Delivery Method']]),
    new Map([['static_text', 'Report Name (optional)']]),
    new Map([['reportNames:guidecheckbox_autoPayElectonic', ['reportNames-autoPayElectonic:guidecheckbox_hsbcNet', 'reportNames-autoPayElectonic:guidecheckbox_hsbcConnect']],
    ['reportNames:guidecheckbox_autoPayCredit', ['reportNames-autoPayCredit:guidecheckbox_hsbcNet', 'reportNames-autoPayCredit:guidecheckbox_hsbcConnect']],
    ['reportNames:guidecheckbox_autoPayStatistics', ['reportNames-autoPayStatistics:guidecheckbox_hsbcNet', 'reportNames-autoPayStatistics:guidecheckbox_hsbcConnect']]
    ])
  ]
  ],
  ['electronicReportFormats:summary', [new Map([['static_text_note', 'Return Report - Daily Report to be printed on the  1st to 3rd Working Day after Value Date.']]),
  new Map([['static_text_heading', 'Report Delivery Method']]),
  new Map([['static_text', 'Report Name (optional)']]),
  new Map([['reportNames:guidecheckbox_autoPayElectonic', ['reportNames-autoPayElectonic:guidecheckbox_hsbcNet', 'reportNames-autoPayElectonic:guidecheckbox_hsbcConnect']],
  ['reportNames:guidecheckbox_autoPayCredit', ['reportNames-autoPayCredit:guidecheckbox_hsbcNet', 'reportNames-autoPayCredit:guidecheckbox_hsbcConnect']],
  ['reportNames:guidecheckbox_autoPayStatistics', ['reportNames-autoPayStatistics:guidecheckbox_hsbcNet', 'reportNames-autoPayStatistics:guidecheckbox_hsbcConnect']]
  ])
  ]
  ]

  ])

  ]
  ],
  ]),
    'guidebutton_saveAndRefresh'
  ]
  ],
  ['hongkong_creditTransferSpecific', [new Map([
    ['guidedropdownlist_eChannelType', ['guidetextbox_hsbcConnectId', 'guidetextbox_hsbcNetId', 'guidetextbox_otherEchannelId']]
  ]),
    'guideaggregateformbox_reversalAccount', 'guideaggregateformbox_paymentCodeDes',
    'dataConfirmation:guidecheckbox_confirm',
    'guidebutton_saveAndRefresh'
  ]
  ],



  ['china_basicDetails', ['guideaggregateformbox_achAccounts', 'guidedropdownlist_serviceChargeAcc', 'guidetextbox_serviceChargeAccName', 'guidebutton_saveAndRefresh']],
  ['china_addressAndContacts', ['guidedropdownlist_addressId', 'guidetextbox_forTheAttentionOf',
    new Map([['guideradiobutton_designateContact', ['guidedropdownlist_contactId']]]),
    'guidebutton_saveAndRefresh'
  ]
  ],
  ['china_creditTransferReports', [new Map([['guideradiobutton_isReportingRequired', ['static_text_title',
    new Map([['reportFormats:guidecheckbox_eChannel', ['guidedropdownlist_echannelId']],
    ['reportFormats:guidecheckbox_other', ['guidetextbox_otherReportFormat']]
    ])

  ]
  ]
  ]),
    'guidebutton_saveAndRefresh'

  ]],


  ['china_creditTransferSpecific', ['static_text_submissionmethodforachcredit',
    new Map([
      ['submissionMethods:guidecheckbox_submissionMethodA', ['guidetextbox_hsbcConnectId', 'guidetextbox_hsbcNetId', 'guideaggregateformbox_submissionAccounts',
        'static_text_reporttype',
        new Map([
          ['reportType:guidecheckbox_cannedReport', ['guidedropdownlist_deliveryMethod']],
          ['reportType:guidecheckbox_dataFeedReport', ['guidedropdownlist_deliveryMethod', 'guidedropdownlist_reportFormat']],
        ]),
      ],

      ],

      ['submissionMethods:guidecheckbox_submissionMethodB', ['guidetextbox_hsbcConnectId', 'guidetextbox_hsbcNetId', 'guideaggregateformbox_submissionAccounts',
        'static_text_formatachreportrequired',
        'reportFormat:guidecheckbox_txt', 'reportFormat:guidecheckbox_xls'
      ]],

    ]),
    'dataConfirmation:guidecheckbox_confirm',
    'guidebutton_saveAndRefresh'
  ]
  ],


  ['bangladesh_basicDetails', ['guideaggregateformbox_achAccounts', 'guidedropdownlist_serviceChargeAcc', 'guidetextbox_serviceChargeAccName', 'guidebutton_saveAndRefresh']],
  ['bangladesh_addressAndContacts', ['guidedropdownlist_addressId', 'guidetextbox_forTheAttentionOf',
    new Map([['guideradiobutton_designateContact', ['guidedropdownlist_contactId']]]),
    'guidebutton_saveAndRefresh'
  ]
  ],
  ['bangladesh_creditTransferReports', [new Map([['guideradiobutton_isReportingRequired', ['static_text_title',
    new Map([['reportFormats:guidecheckbox_eChannel', ['guidedropdownlist_echannelId']],
    ['reportFormats:guidecheckbox_other', ['guidetextbox_otherReportFormat']]
    ])

  ]
  ]
  ]),
    'guidebutton_saveAndRefresh'
  ]],

  ['india_basicDetails', ['guideaggregateformbox_achAccounts', 'guidedropdownlist_serviceChargeAcc', 'guidetextbox_serviceChargeAccName', 'guidebutton_saveAndRefresh']],
  ['india_addressAndContacts', ['guidedropdownlist_addressId', 'guidetextbox_forTheAttentionOf',
    new Map([['guideradiobutton_designateContact', ['guidedropdownlist_contactId']]]),
    'guidebutton_saveAndRefresh'
  ]
  ],
  ['india_creditTransferReports', [new Map([['guideradiobutton_isReportingRequired', ['static_text_title',
    new Map([['reportFormats:guidecheckbox_eChannel', ['guidedropdownlist_echannelId']],
    ['reportFormats:guidecheckbox_other', ['guidetextbox_otherReportFormat']]
    ])

  ]
  ]
  ]),
    'guidebutton_saveAndRefresh'
  ]],

  ['philippines_basicDetails', ['guideaggregateformbox_achAccounts', 'guidedropdownlist_serviceChargeAcc', 'guidetextbox_serviceChargeAccName', 'guidebutton_saveAndRefresh']],
  ['philippines_addressAndContacts', ['guidedropdownlist_addressId', 'guidetextbox_forTheAttentionOf',
    new Map([['guideradiobutton_designateContact', ['guidedropdownlist_contactId']]]),
    'guidebutton_saveAndRefresh'
  ]
  ],
  ['philippines_creditTransferReports', [new Map([['guideradiobutton_isReportingRequired', ['static_text_title',
    new Map([['reportFormats:guidecheckbox_eChannel', ['guidedropdownlist_echannelId']],
    ['reportFormats:guidecheckbox_other', ['guidetextbox_otherReportFormat']]
    ])

  ]
  ]
  ]),
    'guidebutton_saveAndRefresh'
  ]],

  ['southafrica_basicDetails', ['guideaggregateformbox_achAccounts', 'guidedropdownlist_serviceChargeAcc', 'guidetextbox_serviceChargeAccName', 'guidebutton_saveAndRefresh']],
  ['southafrica_addressAndContacts', ['guidedropdownlist_addressId', 'guidetextbox_forTheAttentionOf',
    new Map([['guideradiobutton_designateContact', ['guidedropdownlist_contactId']]]),
    'guidebutton_saveAndRefresh'
  ]
  ],
  ['southafrica_creditTransferReports', [new Map([['guideradiobutton_isReportingRequired', ['static_text_title',
    new Map([['reportFormats:guidecheckbox_eChannel', ['guidedropdownlist_echannelId']],
    ['reportFormats:guidecheckbox_other', ['guidetextbox_otherReportFormat']]
    ])

  ]
  ]
  ]),
    'guidebutton_saveAndRefresh'
  ]],

  ['switzerland_basicDetails', ['guideaggregateformbox_achAccounts', 'guidedropdownlist_serviceChargeAcc', 'guidetextbox_serviceChargeAccName', 'guidebutton_saveAndRefresh']],
  ['switzerland_addressAndContacts', ['guidedropdownlist_addressId', 'guidetextbox_forTheAttentionOf',
    new Map([['guideradiobutton_designateContact', ['guidedropdownlist_contactId']]]),
    'guidebutton_saveAndRefresh'
  ]
  ],
  ['switzerland_creditTransferReports', [new Map([['guideradiobutton_isReportingRequired', ['static_text_title',
    new Map([['reportFormats:guidecheckbox_eChannel', ['guidedropdownlist_echannelId']],
    ['reportFormats:guidecheckbox_other', ['guidetextbox_otherReportFormat']]
    ])

  ]
  ]
  ]),
    'guidebutton_saveAndRefresh'
  ]],

  ['unitedstatesofamerica_basicDetails', ['guideaggregateformbox_achAccounts', 'guidedropdownlist_serviceChargeAcc', 'guidetextbox_serviceChargeAccName', 'guidebutton_saveAndRefresh']],
  ['unitedstatesofamerica_addressAndContacts', ['guidedropdownlist_addressId', 'guidetextbox_forTheAttentionOf',
    new Map([['guideradiobutton_designateContact', ['guidedropdownlist_contactId']]]),
    'guidebutton_saveAndRefresh'
  ]
  ],
  ['unitedstatesofamerica_creditTransferReports', [new Map([['guideradiobutton_isReportingRequired', ['static_text_title',
    new Map([['reportFormats:guidecheckbox_eChannel', ['guidedropdownlist_echannelId']],
    ['reportFormats:guidecheckbox_other', ['guidetextbox_otherReportFormat']]
    ])

  ]
  ]
  ]),
    'guidebutton_saveAndRefresh'
  ]],

  ['bahrain_basicDetails', ['static_text_title',
    new Map([['paymentTypes:guidecheckbox_salary', ['guidedropdownlist_primaryDebitAccId', 'guidedropdownlist_additionalDebitAccountId', 'guideaggregateformbox_firstParty', 'guideaggregateformbox_secondParty']],
    ['paymentTypes:guidecheckbox_sp', ['guidedropdownlist_primaryDebitAccId', 'guidedropdownlist_additionalDebitAccountId', 'guideaggregateformbox_firstParty', 'guideaggregateformbox_secondParty']]
    ]), 'guidedropdownlist_serviceChargeAcc', 'guidetextbox_serviceChargeAccName', 'guidebutton_saveAndRefresh']],
  ['bahrain_addressAndContacts', ['guidedropdownlist_addressId', 'guidetextbox_forTheAttentionOf',
    new Map([['guideradiobutton_designateContact', ['guidedropdownlist_contactId']]]),
    'guidebutton_saveAndRefresh'
  ]
  ],
  ['bahrain_creditTransferReports', [new Map([['guideradiobutton_isReportingRequired', ['static_text_title',
    new Map([['reportFormats:guidecheckbox_eChannel', ['guidedropdownlist_echannelId']],
    ['reportFormats:guidecheckbox_other', ['guidetextbox_otherReportFormat']]
    ])

  ]
  ]
  ]),
    'guidebutton_saveAndRefresh'
  ]],

  ['egypt_basicDetails', ['static_text_title',
    new Map([['paymentTypes:guidecheckbox_salary', ['guidedropdownlist_primaryDebitAccId', 'guidedropdownlist_additionalDebitAccountId', 'guideaggregateformbox_firstParty', 'guideaggregateformbox_secondParty']],
    ['paymentTypes:guidecheckbox_so', ['guidedropdownlist_primaryDebitAccId', 'guidedropdownlist_additionalDebitAccountId', 'guideaggregateformbox_firstParty', 'guideaggregateformbox_secondParty']]
    ]), 'guidedropdownlist_serviceChargeAcc', 'guidetextbox_serviceChargeAccName', 'guidebutton_saveAndRefresh']],
  ['egypt_addressAndContacts', ['guidedropdownlist_addressId', 'guidetextbox_forTheAttentionOf',
    new Map([['guideradiobutton_designateContact', ['guidedropdownlist_contactId']]]),
    'guidebutton_saveAndRefresh'
  ]
  ],
  ['egypt_creditTransferReports', [new Map([['guideradiobutton_isReportingRequired', ['static_text_title',
    new Map([['reportFormats:guidecheckbox_eChannel', ['guidedropdownlist_echannelId']],
    ['reportFormats:guidecheckbox_other', ['guidetextbox_otherReportFormat']]
    ])

  ]
  ]
  ]),
    'guidebutton_saveAndRefresh'
  ]],

  ['qatar_basicDetails', ['static_text_title',
    new Map([['paymentTypes:guidecheckbox_wps', ['guidedropdownlist_primaryDebitAccId', 'guidedropdownlist_additionalDebitAccountId', 'guideaggregateformbox_firstParty', 'guideaggregateformbox_secondParty',
      'guidetextbox_employerEstId', 'guidetextbox_payerEstId', 'guidetextbox_employerCRN', 'guidetextbox_payerIBAN', 'guidetextbox_empName', 'guidetextbox_payerName']],
    ['paymentTypes:guidecheckbox_spo', ['guidedropdownlist_primaryDebitAccId', 'guidedropdownlist_additionalDebitAccountId', 'guideaggregateformbox_firstParty', 'guideaggregateformbox_secondParty']],
    ['paymentTypes:guidecheckbox_nonWps', ['guidedropdownlist_primaryDebitAccId', 'guidedropdownlist_additionalDebitAccountId', 'guideaggregateformbox_firstParty', 'guideaggregateformbox_secondParty']]
    ]), 'guidedropdownlist_serviceChargeAcc', 'guidetextbox_serviceChargeAccName', 'guidebutton_saveAndRefresh']],
  ['qatar_addressAndContacts', ['guidedropdownlist_addressId', 'guidetextbox_forTheAttentionOf',
    new Map([['guideradiobutton_designateContact', ['guidedropdownlist_contactId']]]),
    'guidebutton_saveAndRefresh'
  ]
  ],
  ['qatar_creditTransferReports', [new Map([['guideradiobutton_isReportingRequired', ['static_text_title',
    new Map([['reportFormats:guidecheckbox_eChannel', ['guidedropdownlist_echannelId']],
    ['reportFormats:guidecheckbox_other', ['guidetextbox_otherReportFormat']]
    ])

  ]
  ]
  ]),
    'guidebutton_saveAndRefresh'
  ]],

  ['unitedarabemirates_basicDetails', ['static_text_title',
    new Map([['paymentTypes:guidecheckbox_wps', ['guidedropdownlist_primaryDebitAccId', 'guidedropdownlist_additionalDebitAccountId', 'guidetextbox_employerEstId', 'guideaggregateformbox_emailContactId',
      'guidedropdownlist_smsContactId'
    ]],
    ['paymentTypes:guidecheckbox_spo', ['guidedropdownlist_primaryDebitAccId', 'guidedropdownlist_additionalDebitAccountId', 'guideaggregateformbox_firstParty', 'guideaggregateformbox_secondParty']],
    ['paymentTypes:guidecheckbox_nonWps', ['guidedropdownlist_primaryDebitAccId', 'guidedropdownlist_additionalDebitAccountId', 'guideaggregateformbox_firstParty', 'guideaggregateformbox_secondParty']]
    ]), 'guidedropdownlist_serviceChargeAcc', 'guidetextbox_serviceChargeAccName', 'guidebutton_saveAndRefresh']],
  ['unitedarabemirates_addressAndContacts', ['guidedropdownlist_addressId', 'guidetextbox_forTheAttentionOf',
    new Map([['guideradiobutton_designateContact', ['guidedropdownlist_contactId']]]),
    'guidebutton_saveAndRefresh'
  ]
  ],
  ['unitedarabemirates_creditTransferReports', [new Map([['guideradiobutton_isReportingRequired', ['static_text_title',
    new Map([['reportFormats:guidecheckbox_eChannel', ['guidedropdownlist_echannelId']],
    ['reportFormats:guidecheckbox_other', ['guidetextbox_otherReportFormat']]
    ])

  ]
  ]
  ]),
    'guidebutton_saveAndRefresh'
  ]],

  ['taiwan_basicDetails', ['guideaggregateformbox_achAccounts', 'guidedropdownlist_serviceChargeAcc', 'guidetextbox_serviceChargeAccName', 'guidebutton_saveAndRefresh']],
  ['taiwan_addressAndContacts', ['guidedropdownlist_addressId', 'guidetextbox_forTheAttentionOf',
    new Map([['guideradiobutton_designateContact', ['guidedropdownlist_contactId']]]),
    'guidebutton_saveAndRefresh'
  ]
  ],
  ['taiwan_creditTransferReports', [new Map([['guideradiobutton_isReportingRequired', ['static_text_title',
    new Map([['reportFormats:guidecheckbox_eChannel', ['guidedropdownlist_echannelId']],
    ['reportFormats:guidecheckbox_other', ['guidetextbox_otherReportFormat']]
    ])

  ]
  ]
  ]),
    'guidebutton_saveAndRefresh'
  ]],
  ['taiwan_creditTransferSpecific', [new Map([['transactionCode:guideradiobutton_transactionCode', ['guidetextbox_transactionCodeOther']]]),
    'guidetextbox_remarks', 'dataConfirmation:guidecheckbox_confirm',
    'guidebutton_saveAndRefresh'
  ]
  ],

  ['canada_basicDetails', ['guideaggregateformbox_achAccounts', 'guidedropdownlist_serviceChargeAcc', 'guidetextbox_serviceChargeAccName', 'guidebutton_saveAndRefresh']],
  ['canada_addressAndContacts', ['guidedropdownlist_addressId', 'guidetextbox_forTheAttentionOf',
    new Map([['guideradiobutton_designateContact', ['guidedropdownlist_contactId']]]),
    'guidebutton_saveAndRefresh'
  ]
  ],
  ['canada_creditTransferReports', [new Map([['static_text_heading', 'Report Delivery Method']]),
  new Map([['guidedropdownlist_reportDeliveryMethod', ['guidetextbox_otherReportDeliveryMethod']]]),
    'guidebutton_saveAndRefresh'
  ]],
  ['canada_creditTransferSpecific', ['profileCurrency:guideradiobutton_profileCurrency',
    new Map([['static_text', 'E-Channel (optional)']]),
    'echannels:guidecheckbox_hsbcNetFile', 'echannels:guidecheckbox_hsbcNetACH', 'echannels:guidecheckbox_hostToHost',
    'echannels:guidecheckbox_hsbcFile', 'echannels:guidecheckbox_swift',
    'guidetextbox_hsbcNetId', 'guidetextbox_ftpmailBoxId', 'guidetextbox_hsbcConnectId', 'guidetextbox_shortName',
    'guidetextbox_eftoriginatorId', 'guidetextbox_longName',
    'guidedropdownlist_deliveryMethod',
    'guidedropdownlist_eftoutputFile',
    new Map([['static_text_heading', 'Debit Instructions']]),
    'creditInstruction:guideradiobutton_creditInstruction',
    'guidetextbox_eftauthorisedOffier',
    'guidetextbox_accountAuthorisation',
    'guideaggregateformbox_authorizedAccounts',
    'dataConfirmation:guidecheckbox_confirm',
    'guidebutton_saveAndRefresh'
  ]
  ],


  ['czechrepublic_basicDetails', ['guideaggregateformbox_achAccounts', 'guidedropdownlist_serviceChargeAcc', 'guidetextbox_serviceChargeAccName', 'guidebutton_saveAndRefresh']],
  ['czechrepublic_addressAndContacts', ['guidedropdownlist_addressId', 'guidetextbox_forTheAttentionOf',
    new Map([['guideradiobutton_designateContact', ['guidedropdownlist_contactId']]]),
    'guidebutton_saveAndRefresh'
  ]
  ],
  ['czechrepublic_creditTransferReports', [new Map([['guideradiobutton_isReportingRequired', ['static_text_title',
    new Map([['reportFormats:guidecheckbox_eChannel', ['guidedropdownlist_echannelId']],
    ['reportFormats:guidecheckbox_other', ['guidetextbox_otherReportFormat']]
    ])

  ]
  ]
  ]),
    'guidebutton_saveAndRefresh'
  ]
  ],

  ['kuwait_basicDetails', ['static_text_title',
    new Map([['paymentTypes:guidecheckbox_salary', ['guidedropdownlist_primaryDebitAccId', 'guidedropdownlist_additionalDebitAccountId', 'guideaggregateformbox_firstParty', 'guideaggregateformbox_secondParty']],
    ['paymentTypes:guidecheckbox_sp', ['guidedropdownlist_primaryDebitAccId', 'guidedropdownlist_additionalDebitAccountId', 'guideaggregateformbox_firstParty', 'guideaggregateformbox_secondParty']]
    ]),
    'guidedropdownlist_serviceChargeAcc', 'guidetextbox_serviceChargeAccName', 'guidebutton_saveAndRefresh'
  ]],

  ['kuwait_addressAndContacts', ['guidedropdownlist_addressId', 'guidetextbox_forTheAttentionOf',
    new Map([['guideradiobutton_designateContact', ['guidedropdownlist_contactId']]]),
    'guidebutton_saveAndRefresh'
  ]
  ],
  ['kuwait_creditTransferReports', [new Map([['guideradiobutton_isReportingRequired', ['static_text_title',
    new Map([['reportFormats:guidecheckbox_eChannel', ['guidedropdownlist_echannelId']],
    ['reportFormats:guidecheckbox_other', ['guidetextbox_otherReportFormat']]
    ])

  ]
  ]
  ]),
    'guidebutton_saveAndRefresh'
  ]
  ],

  ['unitedkingdomhsbcuk_basicDetails_newdirect', [
    'guidetextbox_organisationName', 'guidetextbox_organisationID',
    new Map([['guidedropdownlist_frequencyOfSubmission', ['guidetextbox_otherFrequency']]]),
    'guidetextbox_estimatedItems',
    'guideaggregateformbox_bacsCRAcc', 'guidetextbox_serviceUserName',
    'guidedropdownlist_serviceChargeAcc', 'guidetextbox_serviceChargeAccName',
    new Map([['guideradiobutton_submissionOfTestData', []]]),
    'guidetextbox_cin',
    'guidebutton_saveAndRefresh'
  ]
  ],
  ['unitedkingdomhsbcuk_addressAndContacts_newdirect', ['guidedropdownlist_addressId',
    'useAddressForDelivery:guidecheckbox_confirm',
    'guidetextbox_forTheAttentionOf',
    new Map([['guideradiobutton_designateContact', ['guidedropdownlist_contactId']]]),
    'guidebutton_saveAndRefresh'
  ]
  ],
  ['unitedkingdomhsbcuk_creditTransferSpecific_newdirect', ['connectionMethod:guideradiobutton_connectionMethod', 'hardwareServiceModule:guideradiobutton_hardwareServiceModule',
    'static_text_softwaresupplier',
    'guideaggregateformbox_softwareSupplierDirect',
    'static_text_bureaudetails',
    'guidetextbox_bureauName', 'guidetextbox_bureauSUN', new Map([['guideradiobutton_bureauOnYourBehalf', []]]),
    'dataConfirmation:guidecheckbox_confirm',
    'guidebutton_saveAndRefresh'
  ]
  ],
  ['unitedkingdomhsbcuk_primaryAndAdditionalContact_newdirect', ['static_text_staticText', 'guideaggregateformbox_primaryContactDetails', 'guideaggregateformbox_additionalContactDetails', 'guidebutton_saveAndRefresh']],
  ['unitedkingdomhsbcuk_mandateServiceUserTraining_newdirect', ['static_text_title',
    'primaryAndAditionalUserTraining:guidecheckbox_psc1', 'primaryAndAditionalUserTraining:guidecheckbox_psc2',
    'primaryAndAditionalUserTraining:guidecheckbox_ac1', 'primaryAndAditionalUserTraining:guidecheckbox_ac2',
    new Map([['primaryAndAditionalUserTraining:guidecheckbox_other', ['guideaggregateformbox_otherUserTraining']]]),
    'primaryAndAditionalUserTraining:guidecheckbox_naUnderSUN',
    // 'dataConfirmation:guidecheckbox_confirm',
    'guidebutton_saveAndRefresh'
  ]
  ],

  ['unitedkingdomhsbcuk_basicDetails_newindirect', [
    'guidetextbox_organisationName', 'guidetextbox_organisationID',
    new Map([['guidedropdownlist_frequencyOfSubmission', ['guidetextbox_otherFrequency']]]),
    'guidetextbox_estimatedItems',
    'guideaggregateformbox_bacsCRAcc', 'guidetextbox_serviceUserName',
    'guidedropdownlist_serviceChargeAcc', 'guidetextbox_serviceChargeAccName',
    new Map([['guideradiobutton_submissionOfTestData', []]]),
    'guidetextbox_cin',
    'guidebutton_saveAndRefresh'
  ]
  ],
  ['unitedkingdomhsbcuk_addressAndContacts_newindirect', ['guidedropdownlist_addressId',
    'useAddressForDelivery:guidecheckbox_confirm',
    'guidetextbox_forTheAttentionOf',
    new Map([['guideradiobutton_designateContact', ['guidedropdownlist_contactId']]]),
    'guidebutton_saveAndRefresh'
  ]
  ],
  ['unitedkingdomhsbcuk_creditTransferSpecific_newindirect', [
    'static_text_bureaudetails',
    'guideaggregateformbox_bureauDetails',
    'guidebutton_saveAndRefresh'
  ]
  ],
  ['unitedkingdomhsbcuk_primaryAndAdditionalContact_newindirect', ['static_text_staticText', 'guideaggregateformbox_primaryContactDetails', 'guideaggregateformbox_additionalContactDetails', 'guidebutton_saveAndRefresh']],
  ['unitedkingdomhsbcuk_mandateServiceUserTraining_newindirect', ['static_text_title',
    'primaryAndAditionalUserTraining:guidecheckbox_psc1', 'primaryAndAditionalUserTraining:guidecheckbox_psc2',
    'primaryAndAditionalUserTraining:guidecheckbox_ac1', 'primaryAndAditionalUserTraining:guidecheckbox_ac2',
    new Map([['primaryAndAditionalUserTraining:guidecheckbox_other', ['guideaggregateformbox_otherUserTraining']]]),
    'primaryAndAditionalUserTraining:guidecheckbox_naUnderSUN',
    // 'dataConfirmation:guidecheckbox_confirm',
    'guidebutton_saveAndRefresh'
  ]
  ],

  ['unitedkingdomhsbcuk_basicDetails_transferofsponsorshipdirect', [
    'guidetextbox_organisationName', 'guidetextbox_organisationID',
    new Map([['guidedropdownlist_frequencyOfSubmission', ['guidetextbox_otherFrequency']]]),
    'guidetextbox_estimatedItems',
    'guideaggregateformbox_bacsCRAcc', 'guidetextbox_serviceUserName', 'guidetextbox_serviceUserNum',
    'guidedropdownlist_serviceChargeAcc', 'guidetextbox_serviceChargeAccName',
    new Map([['guideradiobutton_submissionOfTestData', []]]),
    'guidetextbox_cin',
    'guidebutton_saveAndRefresh'
  ]
  ],
  ['unitedkingdomhsbcuk_addressAndContacts_transferofsponsorshipdirect', ['guidedropdownlist_addressId',
    'useAddressForDelivery:guidecheckbox_confirm',
    'guidetextbox_forTheAttentionOf',
    new Map([['guideradiobutton_designateContact', ['guidedropdownlist_contactId']]]),
    'guidebutton_saveAndRefresh'
  ]
  ],
  ['unitedkingdomhsbcuk_creditTransferSpecific_transferofsponsorshipdirect', ['connectionMethod:guideradiobutton_connectionMethod', 'hardwareServiceModule:guideradiobutton_hardwareServiceModule',
    'static_text_softwaresupplier',
    'guideaggregateformbox_softwareSupplierDirect',
    'static_text_bureaudetails',
    'guidetextbox_bureauName', 'guidetextbox_bureauSUN', new Map([['guideradiobutton_bureauOnYourBehalf', []]]),
    'dataConfirmation:guidecheckbox_confirm',
    'guidebutton_saveAndRefresh'
  ]
  ],
  ['unitedkingdomhsbcuk_primaryAndAdditionalContact_transferofsponsorshipdirect', ['static_text_staticText', 'guideaggregateformbox_primaryContactDetails', 'guideaggregateformbox_additionalContactDetails', 'guidebutton_saveAndRefresh']],

  ['unitedkingdomhsbcuk_basicDetails_transferofsponsorshipindirect', [
    'guidetextbox_organisationName', 'guidetextbox_organisationID',
    new Map([['guidedropdownlist_frequencyOfSubmission', ['guidetextbox_otherFrequency']]]),
    'guidetextbox_estimatedItems',
    'guideaggregateformbox_bacsCRAcc', 'guidetextbox_serviceUserName', 'guidetextbox_serviceUserNum',
    'guidedropdownlist_serviceChargeAcc', 'guidetextbox_serviceChargeAccName',
    new Map([['guideradiobutton_submissionOfTestData', []]]),
    'guidetextbox_cin',
    'guidebutton_saveAndRefresh'
  ]
  ],
  ['unitedkingdomhsbcuk_addressAndContacts_transferofsponsorshipindirect', ['guidedropdownlist_addressId',
    'useAddressForDelivery:guidecheckbox_confirm',
    'guidetextbox_forTheAttentionOf',
    new Map([['guideradiobutton_designateContact', ['guidedropdownlist_contactId']]]),
    'guidebutton_saveAndRefresh'
  ]
  ],
  ['unitedkingdomhsbcuk_creditTransferSpecific_transferofsponsorshipindirect', ['static_text_bureaudetails',
    'guideaggregateformbox_bureauDetails',
    'guidebutton_saveAndRefresh'
  ]
  ],
  ['unitedkingdomhsbcuk_primaryAndAdditionalContact_transferofsponsorshipindirect', ['static_text_staticText', 'guideaggregateformbox_primaryContactDetails', 'guideaggregateformbox_additionalContactDetails', 'guidebutton_saveAndRefresh']],

  ['unitedkingdomhsbcuk_basicDetails_newdca', [
    'guidetextbox_organisationName', 'guidetextbox_organisationID',
    new Map([['guidedropdownlist_frequencyOfSubmission', ['guidetextbox_otherFrequency']]]),
    'guidetextbox_estimatedItems',
    'guideaggregateformbox_bacsCRAcc', 'guideaggregateformbox_bacsDCA',
    'guidetextbox_serviceUserName',
    'guidedropdownlist_serviceChargeAcc', 'guidetextbox_serviceChargeAccName',
    new Map([['guideradiobutton_submissionOfTestData', []]]),
    'guidetextbox_cin',
    'guidebutton_saveAndRefresh'
  ]
  ],
  ['unitedkingdomhsbcuk_addressAndContacts_newdca', ['guidedropdownlist_addressId',
    'useAddressForDelivery:guidecheckbox_confirm',
    'guidetextbox_forTheAttentionOf',
    new Map([['guideradiobutton_designateContact', ['guidedropdownlist_contactId']]]),
    'guidebutton_saveAndRefresh'
  ]
  ],
  ['unitedkingdomhsbcuk_creditTransferSpecific_newdca', ['connectionMethod:guideradiobutton_connectionMethod', 'hardwareServiceModule:guideradiobutton_hardwareServiceModule',
    'static_text_softwaresupplier',
    'guideaggregateformbox_softwareSupplierDirect',
    'static_text_bureaudetails',
    'guidetextbox_bureauName', 'guidetextbox_bureauSUN', new Map([['guideradiobutton_bureauOnYourBehalf', []]]),
    'dataConfirmation:guidecheckbox_confirm',
    'guidebutton_saveAndRefresh'
  ]
  ],
  ['unitedkingdomhsbcuk_primaryAndAdditionalContact_newdca', ['static_text_staticText', 'guideaggregateformbox_primaryContactDetails', 'guideaggregateformbox_additionalContactDetails', 'guidebutton_saveAndRefresh']],

  ['unitedkingdomhsbcuk_basicDetails_transferofsponsorshipdca', [
    'guidetextbox_organisationName', 'guidetextbox_organisationID',
    new Map([['guidedropdownlist_frequencyOfSubmission', ['guidetextbox_otherFrequency']]]),
    'guidetextbox_estimatedItems',
    'guideaggregateformbox_bacsCRAcc', 'guideaggregateformbox_bacsDCA',
    'guidetextbox_serviceUserName', 'guidetextbox_serviceUserNum',
    'guidedropdownlist_serviceChargeAcc', 'guidetextbox_serviceChargeAccName',
    new Map([['guideradiobutton_submissionOfTestData', []]]),
    'guidetextbox_cin',
    'guidebutton_saveAndRefresh'
  ]
  ],
  ['unitedkingdomhsbcuk_addressAndContacts_transferofsponsorshipdca', ['guidedropdownlist_addressId', 'useAddressForDelivery:guidecheckbox_confirm', 'guidetextbox_forTheAttentionOf',
    new Map([['guideradiobutton_designateContact', ['guidedropdownlist_contactId']]]),
    'guidebutton_saveAndRefresh'
  ]
  ],
  ['unitedkingdomhsbcuk_creditTransferSpecific_transferofsponsorshipdca', ['connectionMethod:guideradiobutton_connectionMethod', 'hardwareServiceModule:guideradiobutton_hardwareServiceModule',
    'static_text_softwaresupplier',
    'guideaggregateformbox_softwareSupplierDirect',
    'static_text_bureaudetails',
    'guidetextbox_bureauName', 'guidetextbox_bureauSUN', new Map([['guideradiobutton_bureauOnYourBehalf', []]]),
    'dataConfirmation:guidecheckbox_confirm',
    'guidebutton_saveAndRefresh'
  ]
  ],
  ['unitedkingdomhsbcuk_primaryAndAdditionalContact_transferofsponsorshipdca', ['static_text_staticText', 'guideaggregateformbox_primaryContactDetails', 'guideaggregateformbox_additionalContactDetails', 'guidebutton_saveAndRefresh']]
])


export const paymentTypeNarrativeMap = new Map([
  ['wps', ['narrative', 'emailAddId']],
  ['spo', ['narrativeSupplier', 'narrativePension', 'narrativeOther']],
  ['nonWps', ['narrative']],
  ['salary', ['narrative']],
  ['sp', ['firstParty_narrativeSupplier_narrativePension', 'secondParty_narrativeSupplier']],
  ['so', ['firstParty_narrativeSupplier_narrativeOther', 'secondParty_narrativeSupplier']],
  ['submissionMethodA', ['achAccountsId', 'paymentSet']],
  ['submissionMethodB', ['achAccountsId', 'paymentSet']],
  ['other', ['trainingContact']],
  ['primaryContactDetails', ['sun']],
  ['additionalContactDetails', ['sun']],
  ['newdirect_primaryContactDetails', ['securityId', 'contactId', 'additionalSUNs', 'workTelephoneNumber', 'workEmailAddress', 'pinPadDevice', 'outOfHoursTelNo', 'primaryDirectPriviledges']],
  ['newdirect_additionalContactDetails', ['securityId', 'contactId', 'additionalSUNs', 'workTelephoneNumber', 'workEmailAddress', 'outOfHoursTelNo', 'securityPassword', 'securityPasswordHint', 'additionalDirectPriviledges']],

  ['transferofsponsorshipdirect_primaryContactDetails', ['securityId', 'contactId', 'additionalSUNs', 'workTelephoneNumber', 'workEmailAddress', 'pinPadDevice', 'outOfHoursTelNo', 'primaryDirectPriviledges']],
  ['transferofsponsorshipdirect_additionalContactDetails', ['securityId', 'contactId', 'additionalSUNs', 'workTelephoneNumber', 'workEmailAddress', 'outOfHoursTelNo', 'securityPassword', 'securityPasswordHint', 'additionalDirectPriviledges']],

  ['newdca_primaryContactDetails', ['securityId', 'contactId', 'additionalSUNs', 'workTelephoneNumber', 'workEmailAddress', 'pinPadDevice', 'outOfHoursTelNo', 'primaryDirectPriviledges']],
  ['newdca_additionalContactDetails', ['securityId', 'contactId', 'additionalSUNs', 'workTelephoneNumber', 'workEmailAddress', 'outOfHoursTelNo', 'additionalDirectPriviledges']],

  ['transferofsponsorshipdca_primaryContactDetails', ['securityId', 'contactId', 'additionalSUNs', 'workTelephoneNumber', 'workEmailAddress', 'pinPadDevice', 'outOfHoursTelNo', 'primaryDirectPriviledges']],
  ['transferofsponsorshipdca_additionalContactDetails', ['securityId', 'contactId', 'additionalSUNs', 'workTelephoneNumber', 'workEmailAddress', 'outOfHoursTelNo', 'additionalDirectPriviledges']],

  ['newindirect_primaryContactDetails', ['securityId', 'contactId', 'additionalSUNs', 'workTelephoneNumber', 'workEmailAddress', 'outOfHoursTelNo', 'securityPassword', 'securityPasswordHint', 'primaryIndirectPriviledges']],
  ['newindirect_additionalContactDetails', ['securityId', 'contactId', 'additionalSUNs', 'workTelephoneNumber', 'workEmailAddress', 'outOfHoursTelNo', 'securityPassword', 'securityPasswordHint', 'additionalIndirectPriviledges']],

  ['transferofsponsorshipindirect_primaryContactDetails', ['securityId', 'contactId', 'additionalSUNs', 'workTelephoneNumber', 'workEmailAddress', 'outOfHoursTelNo', 'securityPassword', 'securityPasswordHint', 'primaryIndirectPriviledges']],
  ['transferofsponsorshipindirect_additionalContactDetails', ['securityId', 'contactId', 'additionalSUNs', 'workTelephoneNumber', 'workEmailAddress', 'outOfHoursTelNo', 'securityPassword', 'securityPasswordHint', 'additionalIndirectPriviledges']]
]);

export const objectToStringFieldMap = new Map([
  ['basicDetails', { emailContactId: ['basicDetails-paymentTypes-emailContactId-emailAddId'] }],
  ['creditTransferSpecific', { paymentCodeDes: ['creditTransferSpecific-paymentCodeDes-description'] }],
  ['mandateServiceUserTraining', { otherUserTraining: ['mandateServiceUserTraining-otherUserTraining-trainingContact'] }],
  ['primaryAndAdditionalContact', { additionalSUNs: ['primaryAndAdditionalContact-primaryContactDetails-additionalSUNs-sun', 'primaryAndAdditionalContact-additionalContactDetails-additionalSUNs-sun'] }]
]);

export const getAggregateBoxMaxCount = (aggregateBoxName) => {
  if (aggregateBoxCount.has(aggregateBoxName)) {
    return aggregateBoxCount.get(aggregateBoxName);
  } else {
    return -1;
  }
}

export const getCountryAccordions = (country) => {
  if (country.split('_')[0] === "unitedkingdomhsbcbankplc") {
    country = 'unitedkingdomhsbcuk_' + country.split('_')[1]
  }
  return countryAccordionMap.get(country);
}

export const getAccordionTitle = (name) => {
  if (accordionTitleMap.has(name)) {
    return accordionTitleMap.get(name)
  } else {
    return 'ACCORDION HEADING'
  }
}



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductAchCredit/mappingFile.js